import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './root';
import { Router } from './router';
import { StoreProvider } from './store';
import { GlobalStateProvider, useGlobalState } from '../context/GlobalStateContext'; // Adjust path
import { pdfjs } from 'react-pdf';
import { useTokenRefresh } from '../../hooks/useTokenRefresh';

// Set worker source, adjust path as needed or use CDN
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

//const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
//const { idPropiedad, setIdPropiedad } = useGlobalState();


const RootWrapper = () => {

  useTokenRefresh('/api/auth/refresh', 60 * 10 * 1000); // refresh every 10 minutes
  return (
    <StoreProvider>
      <GlobalStateProvider>
        <App>
          <Router initialPage="home" />
        </App>
      </GlobalStateProvider>
    </StoreProvider>
  );
};

// index.tsx
createRoot(document.getElementById('app')!).render(<RootWrapper />);